import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/components/layout.vue'

Vue.use(Router)

let router = new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      name: 'login',
      component: resolve => require(['@/pages/login/index.vue'], resolve)
    },
    {
      path: '/secret',
      name: 'secret',
      component: resolve => require(['@/pages/login/secret.vue'], resolve)
    },
    {
      path: '/changePassword',
      name: 'changePassword',
      component: resolve => require(['@/pages/login/changePassword.vue'], resolve)
    },
    {
      path: '/register',
      name: 'register',
      component: resolve => require(['@/pages/login/register.vue'], resolve)
    },
    {
      path: '/manage',
      component: layout,
      children: [
        {
          path: 'HomePage',
          name: '首页',
          component: () => import('@/pages/welcome/index.vue'),
        }
        , {
          path: 'Shipments',
          name: '发临时单',
          component: () => import('@/pages/order/order.vue'),
        },
        {
          path: 'SendLongOrder',
          name: '发长期单',
          component: () => import('@/pages/order/longOrder.vue'),
        },
        {
          path: 'sendEnquiry',
          name: '发询价单',
          component: () => import('@/pages/enquiry/order.vue'),
        },
        {
          path: 'enquiryList',
          name: '询价订单列表',
          component: () => import('@/pages/enquiry/orderList.vue'),
        },
        {
          path: 'OrderProcess',
          name: '订单处理',
          component: () => import('@/pages/order/orderProcess.vue'),
        },
        {
          path: 'orderGetManifestList',
          name: '提货单列表',
          component: () => import('@/pages/order/orderManifestInfo/getManifestInfo/index.vue'),
        },
        {
          path: 'orderSetManifestList',
          name: '送货单列表',
          component: () => import('@/pages/order/orderManifestInfo/setManifestInfo/index.vue'),
        },
        {
          path: 'orderManifestList',
          name: '提送货订单列表',
          component: () => import('@/pages/order/orderManifestInfo/manifestInfo/index.vue'),
        },
        {
          path: 'orderGetManifestDetail',
          name: '提货单详情',
          component: () => import('@/pages/order/manifestDetail/indexg.vue'),
        },
        {
          path: 'orderSetManifestDetail',
          name: '送货单详情',
          component: () => import('@/pages/order/manifestDetail/indexs.vue'),
        },
        {
          path: 'orderManifestReview',
          name: '审核',
          component: () => import('@/pages/order/manifestDetail/review.vue'),
        },
        {
          path: 'AddressBook',
          name: '常用地址簿',
          component: () => import('@/pages/configure/addressBook.vue'),
        }
        , {
          path: 'ReceiptAddressBook',
          name: '回单地址簿',
          component: () => import('@/pages/configure/receiptAddressBook.vue'),
        }
        , {
          path: 'PowerManager',
          name: '组织权限',
          component: () => import('@/pages/autho/index.vue'),
        }
        , {
          path: 'addorg',
          name: '添加组织',
          component: () => import('@/pages/addOrg/index.vue'),
        },
        {
          path: 'NotOverBill',
          name: '未出账单',
          component: () => import('@/pages/archivme/index.vue'),
        },
        {
          path: 'OverBill',
          name: '已出账单',
          component: () => import('@/pages/archivme/outBillOrderList.vue'),
        }, {
          path: 'OverBillInfo',
          name: '已出账单明细',
          component: () => import('@/pages/archivme/outBillOrderInfo.vue'),
        },
        {
          path: 'BillingManager',
          name: '开票管理',
          component: () => import('@/pages/billing/billingManager.vue'),
        },
        {
          path: 'OrderList',
          name: '运输订单列表',
          component: () => import('@/pages/order/orderList.vue'),
        },
        {
          path: 'OrderBiddingApproval',
          // name: '定标价审批列表',
          name: '竞价找车审批列表',
          component: () => import('@/pages/order/orderBiddingApproval/index.vue'),
        },
        {
          path: 'LongOrderList',
          name: '长期订单列表',
          component: () => import('@/pages/order/longOrderList.vue'),
        },
        {
          path: 'BankAccount',
          name: '银行账户',
          component: () => import('@/pages/account/index.vue'),
        },
        {
          path: 'AddCard',
          name: '添加银行卡',
          component: () => import('@/pages/account/addCard.vue'),
        },
        {
          path: 'Bidding_Rule_Manage',
          name: '竞价规则管理',
          component: () => import('@/pages/bidding/ruleManagement.vue'),
        },
        {
          path: 'PlatformAccount',
          name: '平台账户',
          component: () => import('@/pages/account/platformAccount.vue'),
        },
        {
          path: 'AssignMoney',
          name: '金额分配',
          component: () => import('@/pages/account/assignMoney.vue'),
        },
        {
          path: 'FlowMoneyDetail',
          name: '流水明细',
          component: () => import('@/pages/account/flowMoneyDetail.vue'),
        },
        {
          path: 'BackOrderManager',
          name: '回单管理',
          component: () => import('@/pages/order/receiptManagement.vue'),
        },
        {
          path: 'taskPending',
          name: '待办事宜',
          component: () => import('@/pages/processCenter/taskPending.vue'),
        },
        {
          path: 'taskAlreadyMatter',
          name: '我的已办',
          component: () => import('@/pages/processCenter/myCleared.vue'),
        },
        {
          path: 'owsp_approvalGroup',
          name: '审批群组管理',
          component: () => import('@/pages/processCenter/groupManage.vue'),
        },
        {
          path: 'owsp_abnormalProcess',
          name: '结算异常流程',
          component: () => import('@/pages/processCenter/abnormalProcess/index.vue'),
        },
        {
          path: 'owsp_approvalProcess',
          name: '审批流程管理',
          component: () => import('@/pages/processCenter/processManage/index.vue'),
        },
        {
          path: 'myRequest',
          name: '我的请求',
          component: () => import('@/pages/processCenter/myRequest.vue'),
        },
        {
          path: 'CompanyQualification',
          name: '公司资质',
          component: () => import('@/pages/autho/companyQualification.vue'),
        },
        {
          path: 'UsualLine',
          name: '常发线路',
          component: () => import('@/pages/order/usualLine.vue'),
        },
        {
          path: 'Wait_Handle_Order',
          name: '待处理订单',
          component: () => import('@/pages/order/waitHandleOrder.vue'),
        },
        {
          path: 'readyApply',
          name: '准入申请',
          component: () => import('@/pages/readyApply/readyApply.vue'),
        },
        {
          path: 'saasLineManage',
          name: '待招线路管理',
          component: () => import('@/pages/sassBid/waitLineManage.vue'),
        },
        {
          path: 'saasRuleManage',
          name: '招投标规则设置',
          component: () => import('@/pages/sassBid/bidRuleSet.vue'),
        },
        {
          path: 'biddingSaaSManage',
          name: '招投标的管理',
          component: () => import('@/pages/sassBid/bidManage.vue'),
        },
        // {
        //   path: 'hidePage',
        //   name: '招投标的管理',
        //   component: () => import('@/pages/sassBid/bidManage.vue'),
        // },
        {
          path: 'biddingSaaSDetails',
          name: '标的详情',
          meta:{
            title:'标的详情'
          },
          component: () => import('@/pages/sassBid/hidePage.vue'),
        },
        {
          path: 'SaaSReleaseLine',
          name: '发布招标线路',
          meta:{
            title:'发布招标线路'
          },
          component: () => import('@/pages/sassBid/hidePage.vue'),
        },
        {
          path: 'batchRelease',
          name: '批量发标',
          meta:{
            title:'批量发标'
          },
          component: () => import('@/pages/sassBid/hidePage.vue'),
        },
        {
          path: 'ruleDetail',
          name: '规则详情',
          meta:{
            title:'规则详情'
          },
          component: () => import('@/pages/sassBid/hidePage.vue'),
        },
        {
          path: 'tenderDetails',
          name: '投标明细',
          meta:{
            title:'投标明细'
          },
          component: () => import('@/pages/sassBid/hidePage.vue'),
        },
        {
          path: 'addRule',
          name: '新建规则',
          meta:{
            title:'新建规则'
          },
          component: () => import('@/pages/sassBid/hidePage.vue'),
        },
        {
          path: 'ruleSettingCreate',
          name: '新建保证金规则',
          meta:{
            title:'新建保证金规则'
          },
          component: () => import('@/pages/sassBid/hidePage.vue'),
        },
        {
          path: 'sass_earnest_money_rule_setting',
          name: '保证金规则配置',
          meta:{
            title:'保证金规则配置'
          },
          component: () => import('@/pages/sassBid/hidePage.vue'),
        },
        // {this.$router.push("/manage/AddCard");
        //   path: 'bidAgreeManage',
        //   name: '招投标协议管理',
        //   component: () => import('@/pages/sassBid/bidAgreeManage.vue'),
        // },
        {
          path: 'myContract',
          name: '我的合同',
          component: () => import('@/pages/autho/myContract.vue'),
        },
        {
          path: 'personalAuthentication',
          name: '实名认证',
          component: () => import('@/pages/autho/personalAuthentication.vue'),
        },
        {
          path: 'enterpriseCertification',
          name: '企业认证',
          component: () => import('@/pages/autho/enterpriseCertification/index.vue'),
        },
        {
          path: 'orderApprovalFixedPrice',
          name: '一口价找车审核',
          component: () => import('@/pages/order/orderApproval/fixedPrice.vue'),
        },
        {
          path: 'orderApprovalAssignedVehicle',
          name: '指派用车审核',
          component: () => import('@/pages/order/orderApproval/assignedVehicle.vue'),
        },
        {
          path: '*',
          component: () => import('@/components/404.vue'),
        }
      ]
    },
  ]
})

/* router.beforeEach((to, from, next) => {
  store.dispatch('updateRightMsg',{msg:'',status:true});
  Vue.prototype.getBrowser();
  if(firstRoute){
    firstRoute = false;
    setTimeout(function(){
      let login = sessionStorage.getItem('isLogin')
      let path = to.path
      if (path === '/') {
        next()
        return
      }
      if (login) {
        if (path === '/') {
          next({
            path: '/index'
          })
        } else {
          next()
        }
      } else {
        next({
          path: '/'
        })
      }
    },300);
  }else{
    next();
  }
}) */

router.beforeEach((to, from, next) => {
  const name = to.path.slice(to.path.lastIndexOf('/') + 1);
  const menuMap = JSON.parse(sessionStorage.getItem('menuMap') || '{}');
  const permissionArr = menuMap[name] ? menuMap[name].split('-') : [];
  const permissions = permissionArr.reduce((permissions, key) => {
    permissions[key] = true;
    return permissions;
  }, {});
  sessionStorage.setItem('permissions', JSON.stringify(permissions));
  next();
});

export default router
